import { Action } from "./Actions";
import { Participant } from "./Participants";
import { Position } from "./Position";
import { Transition } from "./Transition";
import { Trigger } from "./Triggers";
import { ActualizedParticipant } from "./WorkflowStatus";

export class Activity {
    public id: string;
    public type: ActivityType;
    public condition: string = "";
    public runCondition: string = "";
    public order = 0;
    public killChildren = true;
    public showInWfHistory = true;
    public inheritParticipants = false;
    public inputTransType: IOTransitionType = IOTransitionType.xor;
    public outputTransType: IOTransitionType = IOTransitionType.and;
    public description = "";
    public name = "";
    public isActive = false;

    public actions: Action[];
    public participants: Participant[];
    public activeParticipants: ActualizedParticipant[] = [];
    public triggers: Trigger[];
    public transitions: Transition[];
    public positions: Position[];

    constructor(id: string, type: ActivityType, actions: Action[], participants: Participant[], triggers: Trigger[], transitions: Transition[], positions: Position[]) {
        if (!id)
            throw new Error("Activitty ID cannot be null or empty!");

        this.id = id;
        this.type = type;
        this.actions = actions;
        this.participants = participants;
        this.triggers = triggers;
        this.transitions = transitions;
        this.positions = positions;
    }
}

export enum ActivityType {
    start = "start",
    normal = "normal",
    end = "end",
}

export enum IOTransitionType {
    xor = "xor",
    and = "and",
}
